import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`LKMESSAGE-${key}`)
